import React from 'react';
import { BuyerOfferStatus } from '@/types';
import { BaseStatusIndicatorProps } from '.';
import Indicator, { IndicatorColor } from '@/components/Indicator';
import { useLingui } from '@lingui/react';

interface BuyerOfferStatusIndicatorProps extends BaseStatusIndicatorProps {
    value: BuyerOfferStatus;
}

const colorMap: { [key in BuyerOfferStatus]: IndicatorColor } = {
    Pending: 'warning',
    Rejected: 'danger',
    Accepted: 'success',
    Retracted: 'info',
    Canceled: 'info',
};

const BuyerOfferStatusIndicator: React.FC<BuyerOfferStatusIndicatorProps> = ({ value, children, ...rest }) => {
    const { _ } = useLingui();

    return (
        <Indicator color={colorMap[value]} {...rest}>
            {children || _({ id: `BuyerOfferStatus.${value}` })}
        </Indicator>
    );
};

export default BuyerOfferStatusIndicator;
